import Vue from "vue";
import App from "./App";
import router from "./router/index";
import store from "./store/index";
import i18n from "./lang"; // Internationalization
import PaperDashboard from "./plugins/paperDashboard";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";
import "vue-notifyjs/themes/default.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Dialog from "vue-dialog-loading";
import VTitle from "v-title";
import ElButton from "element-ui";
Vue.use(VTitle);
Vue.use(ElButton);
Raven.config(
  "https://3de22322c359401a94464af1725498cb@o4504887222534144.ingest.sentry.io/4504887288004608"
)
  .addPlugin(RavenVue, Vue)
  .install();
//global config
Vue.use(Dialog, {
  dialogBtnColor: "#0f0",
  background: "rgba(0, 0, 0, 0.5)",
});

Vue.use(PaperDashboard);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
